module.exports = __webpack_public_path__ + "assets/img/11_1102_big.19b012f6.jpg";